const Helper = require('../../helper');
const { default: helper } = require('../../helper');

const TEXTS = {

  cachedPortal : null,
  cachedUserType : null,
  modifiers : {
    sentenceCase : false,
    titleCase : false,
    upperCase : false,
    lowerCase : false
  },

  setModifiers(modifierOptions){
    for (const modifier in modifierOptions) {
      if (modifierOptions.hasOwnProperty(modifier) && this.modifiers.hasOwnProperty(modifier)) {
        this.modifiers[modifier] = modifierOptions[modifier]
      }
    }
  },
  languageType : `en-AU`,

  render(textObjectName, specifier, injectionRenders, options) { // ADD OPTIONS LATER
    var cursor

    // Layer 1: Search By Portal
    if (!this.cachedPortal) {
      this.cachedPortal = helper.getPortalName()
    }
    cursor = this[textObjectName]

    if(!cursor)
      cursor = `Text Not Found for ${textObjectName}!`
    else if(cursor[this.cachedPortal])
      cursor = cursor = cursor[this.cachedPortal]
    else if(cursor[`default`])
      cursor = cursor[`default`]
    
    // Layer 2: Search By User Type
    if(typeof cursor === 'object'){
      if(!this.cachedUserType){
        this.cachedUserType = helper.getUserType();
      }
      cursor = cursor[this.cachedUserType] || cursor
    }
    
    // Layer 3: Search By Specifiers
    if(typeof cursor === 'object'){
        cursor = (specifier && cursor[specifier]) ? cursor[specifier]  : cursor['default']
    }
    
    // Inject Renderables if it exists
    if(injectionRenders && typeof injectionRenders === 'object'){
      for (const key in injectionRenders) {
        if(cursor.indexOf(key) > -1){
          let cursorArr = cursor.split(key)
          cursor = cursorArr[0] + injectionRenders[key] + cursorArr[1]
        }
      }
    }

    // Modifiy
    if(options && options.skipCasing){
      return cursor
    }
    else if(options && options.sentenceCase){
      cursor = this.textToSentenceCase(cursor)
    }
    else if(options && options.upperCase){
      cursor = cursor.toUpperCase()
    }
    else if(options && options.lowerCase){
      cursor = cursor.toLowerCase()
    }

    return cursor
  },
  renderNonAsset(text, options){
    if(options && options.sentenceCase){
      text = this.textToSentenceCase(text)
    }
    if(options && options.upperCase){
      text = text.toUpperCase()
    }
    if(options && options.lowerCase){
      text = text.toLowerCase()
    }

    return text
  },

  // --- MODIFIERS
  textToSentenceCase(text){ // This needs to be optimized haha
    if(!text){
      return text
    }
    text = text.trim()

    // Detect Punction Marks
    const punctuationList = [`. `, `? `, `! `, `?! `] // Lead with period "." because it is more common; Also there are intentional spaces after each punctuation  
    var detectedPunctuationList = []
  
    punctuationList.forEach(punctuation => {
      if(text.indexOf(punctuation) > -1)
        detectedPunctuationList.push(punctuation)
    });
  
    // Defeault if there are no punctuations OR If it's just a single sentence
    if(detectedPunctuationList.length === 0){
      text = toSentenceCase(text)
      text = this.capitalizeProperNouns(text)
      return text
    }
  
    // Identify the primary punctuation
    var primaryPunctiation = detectedPunctuationList[0] // Settle with this for now
    var secondaryPunctuation = detectedPunctuationList.length > 1 ? detectedPunctuationList[1] : null  
    var tertiaryPunctuation = detectedPunctuationList.length > 2 ? detectedPunctuationList[2] : null
    var quaternaryPunctuation = detectedPunctuationList.length > 3 ? detectedPunctuationList[3] : null
  
    var sentences = text.split(primaryPunctiation)
    sentences.forEach((sentence, index) =>{
      var detectedPunctuation
      if(secondaryPunctuation && sentence.indexOf(secondaryPunctuation > -1))
        detectedPunctuation = secondaryPunctuation
      else if(tertiaryPunctuation && sentence.indexOf(tertiaryPunctuation > -1))
        detectedPunctuation = (tertiaryPunctuation)
      else if(quaternaryPunctuation && sentence.indexOf(quaternaryPunctuation > -1))
        detectedPunctuation = (quaternaryPunctuation)
  
  
      if(detectedPunctuation){
        var sentenceParts = sentence.split(detectedPunctuation)
        sentenceParts.forEach((sentencePart, index) => {
          sentenceParts[index] = toSentenceCase(sentencePart)
        });
        sentences[index] = sentenceParts.join(detectedPunctuation).trim()
      }
      else{
        sentences[index] = toSentenceCase(sentence)
      }
    })
  
    var newText = sentences.join(primaryPunctiation).trim()
    newText = this.capitalizeProperNouns(newText)

    return newText

    function toSentenceCase(str){
      return str.substring(0, 1).toUpperCase() + str.substring(1, str.length).toLowerCase()
    }
  },

  capitalizeProperNouns(str){
    const knownPronouns = [
      `Mon`, `Tue `, `Wed`, `Thu`, `Fri`, `Sat`, `Sun`,
      `Monday`, `Tuesday`, `Wednesday`, `Thursday`, `Friday`, `Saturday`, `Sunday`,
      `Jan`, `Feb`, `Mar`, `Apr`, `Jun`, `Jul`, `Aug`, `Sep`, `Oct`, `Nov`, `Dec`,
      `January`, `February`, `March`, `April`, `May`, `June`, `July`, `August`, `September`, `October`, `Novemeber`, `December`,
      `I `,
      `FAQs`,
      `GST`,
      `MM`,
      `YY`,
      `CVN`,
      `Chrome`, `Firefox`, `Safari`, `Edge`,
      `<b>Period:</b>`,
      `Period:`,
      `class="mb-4">Your`,
    ]
    
    knownPronouns.forEach(pronoun => {
      if(str.toLowerCase().indexOf(pronoun.toLowerCase()) > -1){
        var strArr = str.split(" ")
        for (let i = 0; i < strArr.length; i++) {
          if(strArr[i].toLowerCase() === pronoun.toLowerCase()) 
            strArr[i] = strArr[i].split(strArr[i]).join(pronoun)
          else if (strArr[i].replace(/\W/g, '').toLowerCase() === pronoun.toLowerCase())
            strArr[i] = strArr[i].split(strArr[i].replace(/\W/g, '')).join(pronoun)
        }
        str = strArr.join(" ")
      }
    });
    return str
  },

  /* 
          --    Text Assets   --
    Use them in your components with the following syntax:
    {{ TEXTS.render(`HEADER_LOGOUT`) }}

  */

  HEADER_PROFILE : {
    default : `Profile`
  },
  HEADER_FAQ : {
    default : `FAQs`
  },
  HEADER_LOGOUT : {
    default : `Logout`
  },
  HEADER_BTN_BOOK_NOW: {
    default: `Book now`
  },
  
  LOGIN_MAIN_SITE_LINK : {
    default : `Visit our website`,
    thehills: `Return to council website`,
  },

  LOGIN_FORM_REGISTER_TEXT : {
    default : `First time user?`
  },
  LOGIN_FORM_REGISTER_LINK : {
    default : `Register here`
  },
  LOGIN_FORM_HEADER : {
    default : `Login now`
  },
  LOGIN_FORM_SUBHEADER : {
    default : `Please use your registered email address and password to login.`
  },
  LOGIN_FORM_EMAIL_HEADER : {
    default : `Email`
  },
  LOGIN_FORM_EMAIL_PLACEHOLDER : {
    default : `Your email`
  },
  LOGIN_FORM_PASSWORD_HEADER : {
    default : `Password`
  },
  LOGIN_FORM_PASSWORD_PLACEHOLDER : {
    default : `Your password`
  },
  LOGIN_FORM_FORGOTTEN_PASSWORD : {
    default : `Forgot your password?`
  },
  LOGIN_FORM_BTN_LOGIN : {
    default : `Login`
  },
  LOGIN_FORM_VERFICATION_RESENT_SUCCESS : {
    default : `Verification email will be sent. Please check your inbox in the next few minutes`
  },
  
  REGISTRATION_FORM_LOGIN_TEXT : {
    default : `Already have an account?`
  },
  REGISTRATION_FORM_LOGIN_LINK : {
    default : `Login now`
  },
  REGISTRATION_FORM_HEADER : {
    default : `Create an account`
  },
  REGISTRATION_FORM_SUBHEADER : {
    default : `Please complete the details below. We will email your nominated email address for verification.`
  },
  
  REGISTRATION_FORM_FIRSTNAME_HEADER : {
    default : `First name`
  },
  REGISTRATION_FORM_FIRSTNAME_PLACEHOLDER : {
    default : `Your first name`
  },
  REGISTRATION_FORM_LASTNAME_HEADER : {
    default : `Last name`
  },
  REGISTRATION_FORM_LASTNAME_PLACEHOLDER : {
    default : `Your last name`
  },
  REGISTRATION_FORM_PHONE_HEADER : {
    default : `Phone`
  },
  REGISTRATION_FORM_PHONE_PLACEHOLDER : {
    default : `0X XXXX XXXX`
  },
  REGISTRATION_FORM_EMAIL_HEADER : {
    default : `Email address`
  },
  REGISTRATION_FORM_EMAIL_PLACEHOLDER : {
    default : `Email address`
  },
  REGISTRATION_FORM_PASSWORD_HEADER : {
    default : `Password`
  },
  REGISTRATION_FORM_PASSWORD_PLACEHOLDER : {
    default : `Your password`
  },
  REGISTRATION_FORM_PASSWORD_NOTE : {
    default : `Password must include at least one lower case letter, one upper case letter, one number and 8 characters long.`
  },
  REGISTRATION_FORM_PASSWORD_RETYPE_HEADER : {
    default : `Re-type password`
  },
  REGISTRATION_FORM_PASSWORD_RETYPE_PLACEHOLDER : {
    default : `Re-type password`
  },
  REGISTRATION_FORM_PRIVACY_HEADER : {
    default : `Privacy statement`
  },
  REGISTRATION_FORM_BTN_SIGN_UP : {
    default : `Sign up`
  },
  REGISTRATION_FORM_VALIDATION_FIRSTNAME : {
    default : `Invalid firstname`
  },
  REGISTRATION_FORM_VALIDATION_LASTNAME : {
    default : `Invalid lastname`
  },
  REGISTRATION_FORM_VALIDATION_PHONE : {
    default : `Please include area code for landline numbers`
  },
  REGISTRATION_FORM_VALIDATION_PHONE_LIMIT : {
    default : `Invalid phone number`
  },
  REGISTRATION_FORM_VALIDATION_EMAIL : {
    default : `Invalid email`
  },
  REGISTRATION_FORM_VALIDATION_PASSWORD : {
    default : `Password must include at least one lower case letter, one upper case letter, one number and 8 characters long.`
  },
  REGISTRATION_FORM_VALIDATION_RETYPE : {
    default : `Re-type password is not equal to password`
  },
  
  PRIVACY_STATEMENT_CHECKBOX : {
    default : `Please acknowledge you have read and agreed to our privacy statement`
  },
  PRIVACY_STATEMENT_SUBHEADER : {
    default : `We are committed to protecting the privacy of any information you provide and will ensure only authorised personnel have access to your information; this includes Cleanaway and Council staff that are involved in performing and supporting waste services. Please read our <a href="https://www.cleanaway.com.au/privacy-statement/" target="_blank"> Privacy Statement </a>`
  },
  
  FORGOT_PASSWORD_FORM_HEADER : {
    default : `Forgot password`
  },
  FORGOT_PASSWORD_FORM_LOGIN_LINK : {
    default : `Login now`
  },
  FORGOT_PASSWORD_FORM_EMAIL_HEADER : {
    default : `Email`
  },
  FORGOT_PASSWORD_FORM_EMAIL_PLACEHOLDER : {
    default : `Your email`
  },
  FORGOT_PASSWORD_FORM_VALIDATION_EMAIL : {
    default : `Invalid email`
  },
  FORGOT_PASSWORD_FORM_BTN_SUBMIT : {
    default : `Submit`
  },
  FORGOT_PASSWORD_RECOVERY_EMAIL_SENT : {
    default : `Password reset email sent`
  },
  FORGOT_PASSWORD_RECOVERY_EMAIL_NOTE : {
    default : `An email has been sent to detailsEmail. Click the link in the email to reset your password.`
  },
  FORGOT_PASSWORD_RECOVERY_RESEND : {
    default : `Re-send email.`
  },
  


  RESET_PASSWORD_FORM_HEADER : {
    default: `Reset password`
  },
  RESET_PASSWORD_FORM_PASSWORD_HEADER : {
    default: `Password`
  },
  RESET_PASSWORD_FORM_PASSWORD_PLACEHOLDER : {
    default: `Password`
  },
  RESET_PASSWORD_FORM_BTN_RESET_PASSWORD : {
    default: `Reset password`
  },
  RESET_PASSWORD_SUCCESS_HEADER : {
    default: `Password changed successfully`
  },
  RESET_PASSWORD_LOGIN : {
    default: `Return to login`
  },

  INACTIVITY_DETECTION_OKAY : {
    default : `Okay`
  },
  INACTIVITY_DETECTION_EXTEND : {
    default : `Extend`
  },
  INACTIVITY_DETECTION_LOGOUT : {
    default : `Logout`
  },
  
  BOOKING_INACTIVITY : {
    default: `Your session will expire in 60 seconds due to long inactivity. Do you want to extend and stay logged in or logout? Otherwise, you will be automatically logged out.`
  },
  BOOKING_BTN_CHANGE_ADDRESS : {
    default: `Change address`
  },
  BOOKING_BTN_BOOKING_HISTORY : {
    default: {
      default: `Booking history`,
      binCollection : `Booking history / Bin collection schedule`
    },
  },
  BOOKING_LOADING_NOTE : {
    default: `Please do not resubmit your booking or refresh the screen while we process your request, we will be ready to confirm your booking shortly`
  },
  BOOKING_LOADING: {
    default: `LOADING ...`
  },

  BOOKING_SECTION_HEADER_PROFILE : {
    default : `<h2>My profile</h2>`
  },
  BOOKING_SECTION_HEADER_FAQ : {
    default : `<h2>Frequently Asked Questions</h2>`
  },
  ADDRESS_SEARCH_HEADER: { 
    default : "Book a service",
    cardinia : "Book a hard waste collection",
    adelaide : `Book a residential waste service`,
  },
  ADDRESS_SEARCH_NOTFOUND: 'No result found.',
  BOOKING_SEARCH_BAR_PLACEHOLDER : {
    default : `Type address to search…`,
    adelaide: `Type residential address to search…`,
  },
  ADDRESS_PIN_BTN_PIN : {
    default : `Pin`,
    adelaide : `Add to favourites`,
    '1coast' : `Add to favourites`,
  },
  ADDRESS_PIN_BTN_PIN_SUCCESS : {
    default : `Address added to favourites`,
  },
  ADDRESS_PIN_BTN_PINNED : {
    default : `Pinned`,
    adelaide : `Added`,
  },
  ADDRESS_PIN_BTN_BOOKING_HISTORY : {
    default: {
      default: `Booking history`,
      binCollection : `Booking history / Bin collection schedule`,
      moreDetails: `More details`,
    },
  },
  ADDRESS_PIN_BTN_BOOK_NOW : {
    default : `Book now`
  },

  UPCOMING_COLLECTION_SUMMARY_HEADER : {
    default : `Upcoming bin collection`,
  },
  UPCOMING_COLLECTION_SUMMARY_NONE : {
    default : `You do not have upcoming collections.`,
  },

  FAVOURITE_ADDRESS_HEADER : {
    default : `Favourite property addresses`,
    adelaide : `Favourite residential properties`,
  },
  FAVOURITE_ADDRESS_NONE : {
    default : `You don’t have any saved addresses.`
  },
  FAVOURITE_ADDRESS_ITEM_UNPIN : {
    default : `Unpin`,
    adelaide : `Remove`,
  },
  FAVOURITE_ADDRESS_ITEM_UNPIN_SUCCESS : {
    default : `Address removed from favourites`,
  },
  FAVOURITE_ADDRESS_ITEM_BOOKING_HISTORY : {
    default : `Booking history`
  },
  FAVOURITE_ADDRESS_ITEM_BOOK : {
    default : `Book`
  },

  BOOKING_HISTORY_HEADER : {
    default : `Address details`
  },

  BOOKING_STEPS_ONE: {
    default: "Ordering details",
    cardinia: "Ordering details"
  },
  BOOKING_STEPS_TWO: {
    default: {
      res : "Personal info",
      cso : "Resident info"
    },
    cardinia: "Contact information",
  },
  BOOKING_STEPS_THREE: {
    default: {
      default: "Confirmation",
      paid: "Payment",
      free: "Confirmation"
    },
    cardinia: "Booking confirmation"
  },

  ENTITLEMENT_TABLE_HEADER : {
    default  : `selectedServiceGroupName entitlements`,
    cardinia : `Number of hard waste collections you have left`,
    maroondah: `Entitlement summary`
  },
  ENTITLEMENT_TABLE_HISTORY_HEADER : {
    default  : `Entitlement summary`,
    cardinia : `Number of hard waste collections you have left`
  },
  ENTITLEMENT_TABLE_PERIOD_HEADER : {
    default  : `<b>Period:</b> periodDate`,
  },
  ENTITLEMENT_TABLE_HISTORY_PERIOD_HEADER : {
    default  : `<b>Period:</b> entitlementStartDate to entitlementEndDate`,
  },
  ENTITLEMENT_TABLE_FIRST_COL : {
    default  : `Entitlements`,
    cardinia : `Type`
  },
  ENTITLEMENT_TABLE_SECOND_COL : {
    default  : `Entitled`,
    cardinia : `Total`
  },
  ENTITLEMENT_TABLE_THIRD_COL : {
    default  : `Used`
  },
  ENTITLEMENT_TABLE_FOURTH_COL : {
    default  : `Remaining`
  },
  ENTITLEMENT_TABLE_FOOTER : {
    default  : ``,
    adelaide  : {
      default : ``,
      noentitlements : `If your property has used its annual hard waste entitlement, you may purchase additional collections by contacting the City of Adelaide Customer Centre on 8203 7203`
    },
  },
  ENTITLEMENT_TABLE_BTN_VIEW_HISTORY : {
    default  : `View booking history`
  },


  WASTE_SELECTION_SUBHEADING : {
    default : '',
    cardinia : {
      default : '',
      freeHardWaste : "You can leave out up to 2 cubic metres (2m x 1m x 1m) of hard waste for collection. Please select the types of waste you will put out for collection from the options below."
    }
  },

  WASTE_STREAM_OPTION_MAXIMUM_QUANTITY_LABEL : {
    default : '(up to maximumQuantity unitofmeasurement)',
  },
  WASTE_STREAM_OPTION_NO_BOOKING_DATES : {
    default : 'There are no available dates for the selected option',
    "1coast" : 'Bookings for your next available collection date are not yet open. Please return next week to make a booking',
  },

  PREPARATION_NOTE: {
    default : {
      weekly : `Your selectedServiceGroupName will be collected between <b> weekdayFilterStartDesc to weekdayFilterEndDesc </b> of your chosen week. Please place your waste out for collection on <b> preparationDate </b> before your collection week.`,
      predefined_week : `Your selectedServiceGroupName will be collected between <b> weekdayFilterStartDesc to weekdayFilterEndDesc </b> of your chosen week. Please place your waste out for collection on <b> preparationDate </b> before your collection week.`,
      daily : `Please place your waste out for collection on <b> preparationDate </b> before your collection week.`,
      predefined_day : `Please place your waste out for collection on <b> preparationDate </b> before your collection week.`,
      daily_with_default : `Please place your waste out for collection on <b> preparationDate </b> before your collection week.`,
    },
    cardinia : `Your hard waste will be collected sometime between <b> Monday and Friday </b> of your chosen week. Please put your waste out for collection on <b> Saturday or Sunday </b> prior to your chosen week, but no earlier. Waste must be left out no later than <b> 6am preparationDate </b> of your collection week, otherwise it may not be collected.`
  },

  COMMENT_TITLE : {
    default : `Comment`,
    cardinia : `Additional information`
  },
  COMMENT_SUBHEADER : {
    default : `Please provide details in the box below of any instructions to help us complete your request.`,
    marion : `Please provide details in the box below if you do not place your bin directly in front of your property.`,
    cardinia : `If required, please provide any additional information that might help us to complete your collection. This might include information about what is being collected, or specific information about how to find the property or about the collection point.`
  },
  COMMENT_NOTE : {
    default : `Please note that you are about to finalise your booking, <b><u>Booked selectedServiceGroupName can only be CHANGED or CANCELLED over the phone</u></b>. Your booking has been made when you see a customer reference number on the screen.`
  },

  PERSONAL_INFO_HEADER:{
    default : `Personal info`
  },
  PERSONAL_INFO_BOOKING_HEADER:{
    default : {
      res : `Personal info`,
      cso : `Resident info`
    }
  },
  PERSONAL_INFO_SUBHEADER:{
    default : `Please keep your profile updated`
  },
  PERSONAL_INFO_BOOKING_SUBHEADER : {
    default: `Please enter the contact details if we need to contact someone relating to this booking`,
    cardinia : `Please enter your contact details and information in case we need to contact you about your booking.`
  },
  PERSONAL_INFO_FIRSTNAME_HEADER : {
    default : `First name`
  },
  PERSONAL_INFO_LASTNAME_HEADER : {
    default : `Last name`
  },
  PERSONAL_INFO_PHONE_HEADER : {
    default : `Phone number`
  },
  PERSONAL_INFO_PHONE_PLACEHOLDER : {
    default : `0X XXXX XXXX`
  },
  PERSONAL_INFO_PHONE_NOTE : {
    default : `For mobile phone numbers, please enter as 04xxxxxxxx`,
    adelaide : `Please include an area code (ie. 08) for landline telephone numbers.`,
  },
  PERSONAL_INFO_EMAIL_HEADER : {
    default : `Email address`
  },
  PERSONAL_INFO_BTN_UPDATE : {
    default : `Update`
  },
  PERSONAL_INFO_UPDATE_SUCCESS : {
    default : `Your profile has been updated successfully`
  },
  PERSONAL_INFO_VALIDATION_FIRSTNAME : {
    default : `Invalid firstname`
  },
  PERSONAL_INFO_VALIDATION_LASTNAME : {
    default : `Invalid lastname`
  },
  PERSONAL_INFO_VALIDATION_PHONE : {
    default : `Invalid phone`
  },
  PERSONAL_INFO_VALIDATION_EMAIL : {
    default : `Invalid email`
  },
  PERSONAL_INFO_VALIDATION_EMAIL_NO_CHANGE : {
    default : `Updating of email is not allowed`
  },
  CHANGE_PASSWORD_HEADER : {
    default : `Change password`
  },
  CHANGE_PASSWORD_SUBHEADER : {
    default : `Password must include at least one lower case letter, one upper case letter, one number and 8 characters long.`
  },
  CHANGE_PASSWORD_OLD_PASSWORD_HEADER : {
    default : `Old password`
  },
  CHANGE_PASSWORD_OLD_PASSWORD_PLACEHOLDER : {
    default : `Old password`
  },
  CHANGE_PASSWORD_NEW_PASSWORD_HEADER : {
    default : `New password`
  },
  CHANGE_PASSWORD_NEW_PASSWORD_PLACEHOLDER : {
    default : `New password`
  },
  CHANGE_PASSWORD_RETYPE_PASSWORD_HEADER : {
    default : `Re-type new password`
  },
  CHANGE_PASSWORD_RETYPE_PASSWORD_PLACEHOLDER : {
    default : `Re-type new password`
  },
  CHANGE_PASSWORD_BTN_CHANGE_PASSWORD : {
    default : `Change password`
  },
  CHANGE_PASSWORD_VALIDATION_PASSWORD : {
    default : `Invalid password`
  },
  CHANGE_PASSWORD_VALIDATION_NEW_PASSWORD : {
    default : `Password must include at least one lower case letter, one upper case letter, one number and 8 characters long.`
  },
  CHANGE_PASSWORD_VALIDATION_SAME_PASSWORD : {
    default : `New password cannot be the same as your old password`
  },
  CHANGE_PASSWORD_VALIDATION_RETYPE : {
    default : `Re-type password is not equal to Password`
  },
  
  BOOKING_FORM_DETAILS_INACTIVITY : {
    default : `Your session has expired. Kindly reload the page and try again.`
  },
  BOOKING_FORM_DETAILS_WAIT_DONT_GO : {
    default : `If you leave before submitting, your changes will be lost. Would you like to continue?`
  },
  BOOKING_FORM_DETAILS_SHOW_FREE_ENTITLEMENTS : {
    default : `Your request will only use greatestMaxRatio entitlements. Would you like to continue?`
  },
  BOOKING_FORM_DETAILS_MULTIPLE_COLLECTION_NOTICE : {
    default : `You will be using toBeConsumed out of totalEntitlements remaining entitlements`
  },
  BOOKING_FORM_DETAILS_VALIDATION_SERVICE_GROUP : {
    default : `Please select a service`
  },
  BOOKING_FORM_DETAILS_VALIDATION_SERVICE : {
    default : `Please select a service type`
  },
  BOOKING_FORM_DETAILS_VALIDATION_BOOKING_PRODUCTS: {
    default : `Please select a waste type`
  }, 
  BOOKING_FORM_DETAILS_VALIDATION_NO_DATES_AVAILABLE: {
    default : `There are no dates available for your request`
  },
  BOOKING_FORM_DETAILS_VALIDATION_NO_DATES_AVAILABLE_FOR_CITYOFPAE: {
    default : `There are no further entitlements this calendar year for this premises`
  },
  BOOKING_FORM_DETAILS_VALIDATION_NO_DATE_SELECTED: {
    default : `Please select a collection date`
  },
  BOOKING_FORM_DETAILS_VALIDATION_NO_CART: {
    default : `The total cost of Waste Types selected must be greater than zero`
  },
  BOOKING_FORM_DETAILS_NO_COMMENT: {
    default : `Please provide further information about this booking in the comment section`,
    bayswater : `Please provide further information about this booking in the comment section`
  },
  BOOKING_FORM_BTN_BACK: {
    default : `Back`,
  },
  BOOKING_FORM_BTN_NEXT: {
    default : `Next`,
  },
  BOOKING_FORM_BTN_SUBMIT: {
    default : `Submit`,
  },
  BOOKING_FORM_BTN_PAY_NOW: {
    default : `Pay now`,
  },
  BOOKING_FORM_BTN_TO_HOME: {
    default : `Back to home`,
  },
  BOOKING_FORM_END_TERMS_HEADER: {
    default : `Please read and acknowledge these terms and conditions`
  },
  BOOKING_FORM_MULTIPLE_BOOKING_ERROR_MESSAGE: {
    default : `You have an on going booking for the same address. Please check your open tabs.`
  },
  SELECT_SERVICE_GROUP_HEADER: {
    default : `Select a service`,
  },
  SELECT_SERVICE_GROUP_SUBHEADER: {
    default : ``,
    bayswater : `For bin repairs and bin replacement requests, please continue your booking over the phone at 08 9272 0605, Monday to Friday, 8:30 am to 5:00pm. Thank you.`
  },
  SELECT_SERVICE_GROUP_FOOTER: {
    default : ``,
    adelaide : {
      default : ``,
      hardwastecollection : `Hard waste collection is available for residents for large, unwanted household items that do not fit in your red waste bin, such as furniture and white goods. Before booking a hard waste collection, please ensure that you understand and accept the <a href="https://www.cityofadelaide.com.au/resident/home-management/recycling-waste/hard-waste-collection-for-residents/" target="_blank">hard waste collection limits and guidelines</a>.`,
      missedcollection : `If your bin was not collected, you may lodge a request for a missed bin collection here.`,
      binmaintenance : `Before booking a bin repair or replacement, please ensure that you understand and accept the criteria specified in our <a href="https://www.cityofadelaide.com.au/resident/home-management/recycling-waste/bin-repair-replacement-guidelines" target="_blank">bin repair / replacement guidelines</a>. <br><br>If your bin has holes or cracks in the body of the bin, it will need to be <b>replaced</b>. If your bin has a missing or damaged lid, or damaged wheels, it can be <b>repaired</b>. <br><br>Please note that you will need to submit multiple requests if you have <b>more than one bin</b> that needs to be replaced or repaired.`
    },
  },
  
  TERMS_AND_CONDITIONS_SELECTED_YES: {
    default : `Terms and conditions option selected: Yes`
  },

  SELECT_SERVICE_HEADER: {
    default: `Please select`
  },
  SELECT_SERVICE_NO_SERVICES: {
    default: `There are no services available the moment.`
  },
  SELECT_SERVICE_LOADING: {
    default: `Loading services… Please wait.`
  },
  MULTIPLE_COLLECTION_HEADER : {
    default: `Do you have a larger quantity of waste to dispose of?`
  },
  MULTIPLE_COLLECTION_TEXT : {
    default: `If you would like to book for multiple collections, please
    select here:`
  },
  MULTIPLE_COLLECTION_EXCEEDING_REMAINING: {
    default: `You do not have enough entitlements for the selected date. Would you like to proceed with booking remainingEntitlements collections?`
  },

  SELECT_WASTE_TYPE_HEADER : {
    default: `Waste type(s)`,
    marion : {
      default : `Waste type(s)`,
      options : `Options`
    }
  },
  SELECT_WASTE_TYPE_LOADING_RECORDS : {
    default: `Loading Waste Type(s)...`
  },
  SELECT_WASTE_TYPE_NO_RECORDS : {
    default: `No records found`
  },

  WASTE_SELECTION_GROUP_HEADING_PAID : {
    default: `<label class="mb-4">Your paid hardwaste booking is $100 which allows for 2 cubic meters of waste (either general waste, bundled green waste, or a mix of them both), up to 2 mattresses and up to 4 tyres. </label>`
  },
  WASTE_SELECTION_GROUP_HEADING_FREE : {
    default: `<label class="mt-4 mb-4"><i>Only select these options if you have already selected General waste, Bundled green waste or mixed collection from the list above:</i></label>`
  },
  WASTE_SELECTION_OVER_MAX_STREAM_PRICE : {
    default: `Paid collection is $firstMaxStreamPrice per booking. Please select one waste stream applicable with $secondMaxStreamPrice amount.`
  },
  
  BOOKING_SUMMARY_HEADER : {
    default: `Booking summary`
  },
  BOOKING_SUMMARY_NO_DATE_SELECTED : {
    default: `Date not yet selected`
  },
  BOOKING_SUMMARY_TOTAL_AMMOUNT : {
    default: `Total amount`
  },
  BOOKING_SUMMARY_TOTAL_COLLECTIONS : {
    default: `Total collections`
  },
  BOOKING_SUMMARY_ENTITLED_COLLECTIONS : {
    default: `Entitled collections`
  },
  BOOKING_SUMMARY_COLLECTIONS_ERROR : {
    default: `You do not have enough entitlements.<br> Kindly update your selection(s).`
  },
  BOOKING_SUMMARY_COLLECTIONS_ERROR_NOHTML : {
    default: `You do not have enough entitlements. Kindly update your selection(s).`
  },
  BOOKING_SUMMARY_SUBTOTAL : {
    default: `Subtotal`
  },
  BOOKING_SUMMARY_COMPUTATION : {
    default: `GST`
  },
  BOOKING_SUMMARY_BOOKING_DATE : {
    default: `Booking date`,
    thehills: `Received`,
  },
  BOOKING_SUMMARY_REF_NO : {
    default: `CRN`
  },
  BOOKING_SUMMARY_SECTION_FOUR_COL_HEAD_1 : {
    default: `Requested date`,
    "1coast": `Scheduled date`,
  },
  BOOKING_SUMMARY_SECTION_FOUR_COL_HEAD_2 : {
    default: `Service`
  },
  BOOKING_SUMMARY_SECTION_FOUR_COL_HEAD_3 : {
    default: `Waste type`
  },

  COLLECTION_WEEK_SUBHEADER : {
    default : `Please use the calendar below to select the date that you would like your hard waste to be collected.`,
    bayswater : {
      default : `Please use the calendar below to select the date that you would like your hard waste to be collected.`,
      bulkbin : `Please use the calendar below to select the date that you would like your bulk bin to be delivered.`,
      mattress : `Please use the calendar below to select the date that you would like your mattress(es) to be delivered.`,
      whitegoods : `Please use the calendar below to select the date that you would like your white good(s) to be delivered.`
    }
  },
  COLLECTION_WEEK_PERIOD_SELECTED : {
    default: `periodTypeDescriptor selected`
  },
  COLLECTION_WEEK_PICKUP_DATE : {
    default: `Pickup date`
  },
  COLLECTION_WEEK_NOT_ENOUGH_ENTITLEMENTS : {
    default: `You do not have enough entitlements for the selected date. Would you like to proceed with booking numberOfCollections collections?`,
  },

  PAYMENT_SECTION_HEADER : {
    default: `Payment`
  },
  PAYMENT_SECTION_NAME_HEADER : {
    default: `Card holder name`
  },
  PAYMENT_SECTION_NAME_PLACEHOLDER : {
    default: `Your card holder name`
  },
  PAYMENT_SECTION_CARD_NUMBER_HEADER : {
    default: `Card number`
  },
  PAYMENT_SECTION_CARD_NUMBER_PLACEHOLDER : {
    default: `Your card number`
  },
  PAYMENT_SECTION_CARD_EXPIRY_HEADER : {
    default: `Expiry date`
  },
  PAYMENT_SECTION_CARD_EXPIRY_MONTH_PLACEHOLDER : {
    default: `MM`
  },
  PAYMENT_SECTION_CARD_EXPIRY_YEAR_PLACEHOLDER : {
    default: `YY`
  },
  PAYMENT_SECTION_CARD_CVN_HEADER : {
    default: `CVN`
  },
  PAYMENT_SECTION_CARD_CVN_PLACEHOLDER : {
    default: `123`
  },

  PAYMENT_SECTION_VALIDATION_NAME : {
    default : `Invalid holder name`
  },
  PAYMENT_SECTION_VALIDATION_CARD_NUMBER : {
    default : `Invalid credit card number`
  },
  PAYMENT_SECTION_VALIDATION_CARD_EXPIRY_MONTH : {
    default : `Invalid expiry month`
  },
  PAYMENT_SECTION_VALIDATION_CARD_EXPIRY_YEAR : {
    default : `Invalid expiry year`
  },
  PAYMENT_SECTION_VALIDATION_CARD_CVN : {
    default : `Invalid cvn`
  },
  PAYMENT_SECTION_VALIDATION_TERMS : {
    default : `Please accept the terms and conditions`
  },

  BOOKING_COMPLETED_THANK_YOU_HEADER : {
    default : {
      paid : `Thank you! Your payment has been confirmed.`,
      free : `Thank you! Your booking has been processed.`,
    },
  },
  BOOKING_COMPLETED_THANK_YOU_SUBHEADER : {
    default : `Your booking has been received successfully. We’ve sent you an email to <strong>yourEmail</strong> for confirmation.`,
  },
  MULTIPLE_SERVICE_SERVICE_GROUP_BOOKING_ADD_NEW: {
    default: `Add another service`
  },
  SERVICE_GROUP_SWITCH_CLEAR_CONFIRM: {
    default: `Would you like to clear your previous requests?`
  },
  SERVICE_SWITCH_VALIDATION_INCOMPLETE: {
    default: `Please select a yourItem`
  },
  SERVICE_AND_GROUP_QUICK_CLEAR_CONFIRM: {
    default: `Would you like to clear all wastes?`
  },
  SERVICE_FREE_STILL_REMAINING: {
    default: `serviceName is still remaining.`
  },
  MULTIPLE_SERVICE_INCOMPLETE_DATE_SELECTION: {
    default: `Please complete all collection dates selection`
  },
  BIN_COLLECTION_FIRST_COL : {
    default  : `Bin Type`,
  },
  BIN_COLLECTION_SECOND_COL : {
    default  : `Size`,
  },
  BIN_COLLECTION_THIRD_COL : {
    default  : `Quantity`
  },

  ADDRESS_DETAILS_TABLE_FIRST_COL : {
    default  : `CRN`,
  },
  ADDRESS_DETAILS_TABLE_SECOND_COL : {
    default  : `WASTE TYPE`,
  },
  ADDRESS_DETAILS_TABLE_THIRD_COL : {
    default  : `REQUEST DATE`
  },
  ADDRESS_DETAILS_TABLE_FOURTH_COL : {
    default  : `SCHEDULE DATE`
  },
  ADDRESS_DETAILS_TABLE_FIFTH_COL : {
    default  : `COMPLETION DATE`
  },
  ADDRESS_DETAILS_TABLE_SIXTH_COL : {
    default  : `BULK UP USED`
  },
  ADDRESS_DETAILS_TABLE_SEVENTH_COL : {
    default  : `REASON`
  },
  ADDRESS_DETAILS_TABLE_EIGTH_COL : {
    default  : `CUSTOMER NAME`
  },
  ADDRESS_DETAILS_TABLE_NINTH_COL : {
    default  : `CUSTOMER CONTACT`
  },
  ERROR_EXCEEDED_BOOKING_QTY_CAP : {
    default : `You have exceeded the allowed quantity for collection (Up to wasteStreamQty wasteStreamName).\nKindly update your selection(s).`,
  },
  ERROR_WO_EMAIL_NOTIF_FAILURE: {
    default: `Booking successful. But an error was encountered while sending your email confirmation. Please take note of your booking details.`
  },
  REQUESTCANCELLATION_HEADER: {
    default:  `Booking Details`
  },
  REQUESTCANCELLATION_SUBHEADER: {
    default:  `<p>*Requests must be made 48 hours prior collection</p>`
  },
  REQUESTCANCELLATION_PROPERTY_ADDRESS: {
    default: `Property Address`
  },
  REQUESTCANCELLATION_CRN: {
    default: `CRN`
  },
  REQUESTCANCELLATION_CRN_PLACEHOLDER: {
    default: `XXX-XXXXXXX`
  },
  REQUESTCANCELLATION_BTN_SUBMIT: {
    default: `Submit`
  },
  BOOKING_SECTION_HEADER_REQUESTCANCELLATION: {
    default: `<h2>Request for cancellation</h2>`
  },
  REQUESTCANCELLATION_PROPERTY_ADDRESS_VALIDATION: {
    default: `Invalid property address`
  },
  REQUESTCANCELLATION_CRN_VALIDATION: {
    default: `Invalid CRN`
  },
  REQUESTCANCELLATION_CRN_DATE_VALIDATION: {
    default: `Your request date is requestDate. You can only cancel cancelDay in advance`
  },
  REQUESTCANCELLATION_REQUEST_DATE: {
    default: `Requested Date`
  },
  BROWSER_NOT_SUPPORTED: {
    default: `Your web browser (browser) is out of date. Update your browser for more security, speed and the best experience on this site.`
  },
  CSO_BOOKING_MANAGEMENT_HEADER: {
    default: 'Queued Bookings'
  }
}

module.exports = TEXTS